// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import common from '@/assets/common.js'
import VueCookies from 'vue-cookies'
import i18n, { setForcedLocale } from './i18n'
import '@/styles/global.css'
// import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

Vue.config.productionTip = false
Vue.use(VueCookies)

async function globalInit() {
  console.log('global init')
}

/* eslint-disable no-new */
fetch('/static/config.json')
  .then(response => response.json())
  .then((config) => {

    // Sentry.init({
    //   Vue,
    //   dsn: config.sentryDsn,
    //   integrations: [new Integrations.BrowserTracing()],

    //   // We recommend adjusting this value in production, or using tracesSampler
    //   // for finer control
    //   tracesSampleRate: config.tracesSampleRate,
    // });

    Vue.prototype.$config = config
    Vue.prototype.$common = common
    Vue.prototype.$publicPath = config.assetsPublicPath || '/';
    // eslint-disable-next-line no-undef
    __webpack_public_path__ = config.assetsPublicPath || '/'

    // 如果 config.json 中指定了 region，强制设置语言
    if (config.region) {
      const regionToLocale = { 'cn': 'zh', 'global': 'en' }
      setForcedLocale(regionToLocale[config.region] || config.region, config.region)
    }

    /*
    new Vue({
      el: '#app',
      router,
      components: { App },
      template: '<App/>'
    })
    */
    /* eslint-disable no-new */

    globalInit().then(() => {
      new Vue({
        el: '#app',
        store,
        router,
        i18n,
        // replace the content of <div id="app"></div> with App
        render: h => h(App)
      })
    })
  })
/*
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
*/



// WEBPACK FOOTER //
// ./src/main.js